    <div [class]="layoutOuter">
      <div [class]="layoutSidePanel">
        <div class="absolute inset-0 z-0 bg-linear-to-tr from-navy via-navy/50 to-emerald/30"></div>
        <div class="absolute inset-0 z-0 bg-cover bg-center" [style.backgroundImage]="'url(' + sidePanelBgImage + ')'"></div>
        <div [class]="layoutOverlay"></div>
        <div class="relative z-10">
          <div class="flex items-center gap-3 mb-8">
            <div class="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center border border-white/20">
              <img ngSrc="logo-white.svg" height="24" width="24" alt="BAILIA" class="w-6 h-6"/>
            </div>
            <span class="text-xl font-bold tracking-wide">BAILIA</span>
          </div>
        </div>

        <div class="absolute bottom-12 left-12 right-12 text-white">
          <h2 class="text-4xl font-display font-bold mb-4 leading-tight text-white">
            L'immobilier repensé pour <br />votre sérénité.
          </h2>
          <p class="text-lg text-gray-200 max-w-md font-light">
            Que vous soyez propriétaire ou locataire, BAILIA simplifie chaque étape de votre parcours immobilier.
          </p>
          <div class="flex gap-2 mt-8">
            <div class="h-1 w-8 bg-white rounded-full"></div>
            <div class="h-1 w-2 bg-white/30 rounded-full"></div>
            <div class="h-1 w-2 bg-white/30 rounded-full"></div>
          </div>
        </div>
      </div>

      <div class="flex-1 flex flex-col items-center justify-center p-4 md:p-12 overflow-y-auto">
        <div class="w-full max-w-md space-y-8">
          <z-card class="p-8 text-center space-y-6 shadow-xl border-0 md:shadow-none md:p-0 md:bg-transparent">
            <div class="md:hidden flex justify-center mb-6">
              <div class="w-24 h-24 bg-[#1A2E47] rounded-2xl flex items-center justify-center shadow-lg">
                <img ngSrc="logo-white.svg" height="16" width="16" alt="BAILIA" class="w-16 h-16"/>
              </div>
            </div>

            <div>
              <h1 class="text-3xl lg:text-4xl font-display font-bold text-navy mb-4">Bienvenue sur BAILIA</h1>
              <p class="text-gray-500 text-lg">
                Connectez-vous pour gérer vos biens ou trouver votre prochain logement.
              </p>
            </div>

            <div class="space-y-4 pt-4">
              <button
                z-button
                type="button"
                class="w-full bg-emerald hover:bg-emerald/90 text-white h-14 rounded-full text-lg font-semibold shadow-lg shadow-emerald/20 transition-all hover:scale-[1.02] active:scale-[0.98]"
                (click)="router.navigate(['/signup'])"
              >
                Commencer
              </button>
              <button
                z-button
                type="button"
                zType="outline"
                class="w-full h-14 rounded-full text-lg font-medium border-2 border-gray-200 text-navy hover:border-navy hover:bg-gray-50 transition-all"
                (click)="router.navigate(['/signin'])"
              >
                J'ai déjà un compte
              </button>
            </div>
          </z-card>
        </div>
      </div>
    </div>
